// Snapshot only the shell resources this overlay changes. The route stays mounted.
export const lockMobileChatBackground = (
  backgrounds: HTMLElement[],
  scrollRoot: HTMLElement | null,
  trigger: HTMLElement | null
) => {
  const pageUrl = window.location.href;
  const pageKey = window.history.state?.key;
  const canRestoreFocus = () => trigger?.isConnected && !trigger.closest('[inert]') &&
    window.location.href === pageUrl && window.history.state?.key === pageKey;
  const attributes = backgrounds.map(element => ({
    element, inert: element.getAttribute('inert'), hidden: element.getAttribute('aria-hidden')
  }));
  const scrollers = scrollRoot
    ? [scrollRoot, ...backgrounds.flatMap(element =>
      [element, ...Array.from(element.querySelectorAll<HTMLElement>('*'))])]
      .filter(element => element.scrollTop !== 0 || element.scrollLeft !== 0 ||
        (/(auto|scroll)/.test(getComputedStyle(element).overflowY) &&
          element.scrollHeight > element.clientHeight))
    : [];
  const positions = scrollers.map(element => ({ element, x: element.scrollLeft, y: element.scrollTop }));
  const locked = Array.from(new Set([document.documentElement, document.body, ...scrollers]));
  const styles = locked.map(element => ({
    element, overflow: element.style.overflow,
    overflowX: element.style.overflowX, overflowY: element.style.overflowY
  }));
  const overscroll = document.body.style.overscrollBehavior;
  const windowPosition = { x: window.scrollX, y: window.scrollY };
  attributes.forEach(({ element }) => {
    element.setAttribute('inert', '');
    element.setAttribute('aria-hidden', 'true');
  });
  styles.forEach(({ element }) => { element.style.overflow = 'hidden'; });
  document.body.style.overscrollBehavior = 'none';

  return () => {
    attributes.forEach(({ element, inert, hidden }) => {
      if (element.getAttribute('inert') === '') {
        if (inert === null) element.removeAttribute('inert');
        else element.setAttribute('inert', inert);
      }
      if (element.getAttribute('aria-hidden') === 'true') {
        if (hidden === null) element.removeAttribute('aria-hidden');
        else element.setAttribute('aria-hidden', hidden);
      }
    });
    styles.forEach(({ element, overflow, overflowX, overflowY }) => {
      if (element.style.overflow === 'hidden') {
        element.style.overflow = overflow;
        element.style.overflowX = overflowX;
        element.style.overflowY = overflowY;
      }
    });
    if (document.body.style.overscrollBehavior === 'none') document.body.style.overscrollBehavior = overscroll;
    positions.forEach(({ element, x, y }) => { element.scrollLeft = x; element.scrollTop = y; });
    window.scrollTo(windowPosition.x, windowPosition.y);
    if (canRestoreFocus()) trigger?.focus({ preventScroll: true });
    // Native history traversal may restore focus after popstate dispatch.
    // Finish after that restoration, without stealing focus from a new dialog.
    window.requestAnimationFrame(() => {
      if (canRestoreFocus() &&
          (document.activeElement === trigger || document.activeElement === document.body)) {
        trigger?.focus({ preventScroll: true });
      }
    });
  };
};
